import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/public-icon.module.scss'
import { Globe } from 'lucide-react'

export default function PublicIcon(props) {
    const { contextStyles, hoverStyles, selectedStyles } = props
    return (
        <div className={cn(styles.publicIcon, contextStyles, hoverStyles, selectedStyles)}>
            <Globe />
        </div>
    )
}
